<template>
  <div id="app">
    <div id="nav"></div>
    <router-view />
  </div>
</template>

<script>
const MP_FLAG_KEY = '_is_miniprogram';

export default {
  name: 'App',
  mounted() {
    this.detectMiniProgram();
    this.detectOpenId();
  },
  methods: {
    detectMiniProgram() {
      const store = this.$store;

      try {
        const saved = localStorage.getItem(MP_FLAG_KEY);
        if (saved === 'true') {
          store.commit('set_is_xcx', true);
          return;
        }
      } catch (e) { }

      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('wxxcx') === 1) {
        store.commit('set_is_xcx', true);
        try {
          localStorage.setItem(MP_FLAG_KEY, 'true');
        } catch (e) { }
        return;
      }

      if (window.__wxjs_environment === 'miniprogram') {
        store.commit('set_is_xcx', true);
        try {
          localStorage.setItem(MP_FLAG_KEY, 'true');
        } catch (e) { }
        return;
      }

      this.tryWxDetect(store, 0);
    },

    tryWxDetect(store, retryCount) {
      const maxRetries = 10;
      const interval = 200;

      if (typeof wx !== 'undefined' && wx.miniProgram && wx.miniProgram.getEnv) {
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            store.commit('set_is_xcx', true);
            try {
              localStorage.setItem(MP_FLAG_KEY, 'true');
            } catch (e) { }
          } else {
            store.commit('set_is_xcx', false);
          }
        });
      } else if (retryCount < maxRetries) {
        setTimeout(() => {
          this.tryWxDetect(store, retryCount + 1);
        }, interval);
      } else {
        store.commit('set_is_xcx', false);
      }
    },

    detectOpenId() {
      const urlParams = new URLSearchParams(window.location.search);
      const openid = urlParams.get('openid');
      if (openid) {
        const store = this.$store;
        store.commit('set_openid', openid);
        store.commit('set_is_xcx', true);
        //console.log("detectOpenId: ", openid);
        try {
          localStorage.setItem(MP_FLAG_KEY, 'true');
        } catch (e) { }
        this.autoWxLogin(openid);
      }
    },

    autoWxLogin(openid) {
      const qs = require("qs");
      this.$axios
        .post("/api/user/wx_auto_login", qs.stringify({ openid: openid }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$store.commit("set_is_login", true);
          }
        })
        .catch(() => { });
    }
  }
};
</script>

<style>
@import "../src/assets/hkapp.css";
</style>